/* =================== CLIENTES =================== */
$(function () {
  $(".carrosel-clientes").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1119,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
});
